import React from "react";
import ProfileHeader from "../../organism/profile/profileHeader";
import ProfileCentral from "../../organism/profile/profileCentral";

const ProfilePage = () => {
    return (
        <>
            <ProfileHeader/>
            <ProfileCentral/>
        </>
    )
}

export default ProfilePage